import { FLOW_STEPS } from "../../constants/flow.js";
import styles from "./Stepper.module.css";

const Stepper = ({ current = "identify", steps = FLOW_STEPS }) => {
  const currentIndex = Math.max(0, steps.findIndex((step) => step.id === current));
  return (
    <ol className={styles.list} aria-label="Progresso da solicitação">
      {steps.map((step, index) => {
        const state = index < currentIndex ? "done" : index === currentIndex ? "current" : "upcoming";
        return (
          <li
            key={step.id}
            className={`${styles.item} ${styles[state]}`}
            aria-current={state === "current" ? "step" : undefined}
          >
            <span className={styles.dot} aria-hidden="true">{index < currentIndex ? "✓" : index + 1}</span>
            <span className={styles.label}>{step.label}</span>
          </li>
        );
      })}
    </ol>
  );
};

export default Stepper;
